import { SelectOption } from "../../components/dropdown/Dropdown";
import { ActionLinkConfig } from "../../components/helpers/CustomFieldRenderers/SearchListFieldRenderer/SearchListRenderer";
import {
  ACTION_KEY,
  ACTION_SELECTED_ID_KEY,
  APP_ROUTES,
  FILTER_KEY,
  endpoints,
} from "../../config";
import {} from "./models";
import { useNavigate } from "react-router-dom";

export const nestedEndpointConfig = {
  // siteUsersID:
  //   endpoints.projectmanagement.nestedPages.workflows.search.siteUsers,
};

export const endpointConfig = {
  // siteIds: endpoints.workflows.search.sites,
  // siteUserID: endpoints.workflows.search.siteUsers,
  // projectsIds: endpoints.workflows.search.projects,
};
// TODO - UpdateConfig as modules are added
export const linkConfig: ActionLinkConfig = {
  workflowsID: {
    text: "View workflow",
    permissionKey: "view",
    location: APP_ROUTES.workflowconfiguration,
  },
  projectsID: {
    text: "View project",
    permissionKey: "view",
    location: APP_ROUTES.projects,
  },
};

export const actionLinkTextConfig = {
  // NOTE: Left out for now as advised by Josh, this will need implementing if we do end up needing it though:
  // workflowsID: {
  //   text: "Add new workflow",
  //   permissionKey: "create",
  //   location: "/workflowconfiguration",
  // },
  // projectsID: {
  //   text: "Add new project",
  //   permissionKey: "create",
  //   location: "/projects",
  // },
};

export const onLinkClick = <T>(field: keyof T, option: SelectOption) => {
  const navigate = useNavigate();
  let filterString: string | null = null;
  let route: string | null = null;
  let action: string | null = null;
  let actionSelectedId: string | null = null;
  switch (field) {
    case "sitesID":
      filterString = `Sites__Id EQ (${option.value})`;
      route = APP_ROUTES.sites;
      action = "VIEW";
      actionSelectedId = `${option.value}`;
      break;
    case "projectsID":
      filterString = `Projects__Id EQ (${option.value})`;
      route = APP_ROUTES.projects;
      action = "VIEW";
      actionSelectedId = `${option.value}`;
      break;
    case "siteUsersID":
      // console.log("here");
      filterString = `PlatformUsers__Id EQ (${option.value})`;
      route = APP_ROUTES.platformUsers;
      action = "VIEW";
      actionSelectedId = `${option.value}`;
      break;
  }
  // console.log(filterString);
  if (filterString) {
    window.localStorage.setItem(FILTER_KEY, filterString);
  }

  if (action) {
    window.localStorage.setItem(ACTION_KEY, action);
  }

  if (actionSelectedId) {
    window.localStorage.setItem(ACTION_SELECTED_ID_KEY, actionSelectedId);
  }

  if (route) {
    navigate(route);
  }
};
export const onActionLinkClick = <T>(field: keyof T) => {
  const navigate = useNavigate();
  let action = "";
  let route = "";

  switch (field) {
    case "sitesID":
      route = APP_ROUTES.sites;
      action = "CREATE";
      break;
    case "projectsID":
      route = APP_ROUTES.projects;
      action = "CREATE";
      break;
    case "siteUsersID":
      route = APP_ROUTES.platformUsers;
      route = APP_ROUTES.platformUsers;
      action = "CREATE";
      break;
  }

  window.localStorage.setItem(ACTION_KEY, action);
  navigate(route);
};
